const books = [
  {
    recent: true,
    image: "https://images-na.ssl-images-amazon.com/images/I/81-QB7nDh4L.jpg",
    featured: true,
    title: "The lean startup",
    tags: ["Moivational"],
    authors: ["Diomidis Spinellis", "Jude Agboola"],
    rating: 4,
    reads: 40,
    likes: 39,
    year: 2020,
    status: "available",
  },
  {
    recent: true,
    image:
      "https://i.guim.co.uk/img/media/931f8682237a7258b3dbd2e9d9bf27ec2df31798/0_0_1664_2560/master/1664.jpg?width=700&quality=85&auto=format&fit=max&s=42c506090d254d5361bb66431eee12df",
    featured: true,
    title: "12 Rules for Life",
    tags: ["Moivational"],
    authors: ["Diomidis Spinellis", "Jude Agboola"],
    rating: 4,
    reads: 40,
    likes: 39,
    year: 2020,
    status: "available",
  },
  {
    recent: true,
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1445789755l/26311939.jpg",
    featured: true,
    title: "Effective Python",
    tags: ["Moivational"],
    authors: ["Diomidis Spinellis"],
    rating: 4,
    reads: 40,
    likes: 39,
    year: 2020,
    status: "available",
  },
  {
    recent: false,
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1441822839l/153234._SY475_.jpg",
    featured: true,
    title: "Built to Last",
    tags: ["Moivational"],
    authors: ["Diomidis Spinellis"],
    rating: 4,
    reads: 40,
    likes: 39,
    year: 2020,
    status: "Borrowed out",
  },
  {
    recent: true,
    image:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1427583285l/25238425.jpg",
    featured: true,
    title: "The Effective Engineer",
    tags: ["Moivational"],
    authors: ["Diomidis Spinellis", "Jude Agboola"],
    rating: 4,
    reads: 40,
    likes: 39,
    year: 2020,
    status: "available",
  },
  {
    recent: true,
    image: "https://covers.openlibrary.org/b/id/9950409-L.jpg",
    featured: true,
    title: "Big Magic",
    tags: ["Moivational"],
    authors: ["Diomidis Spinellis"],
    rating: 4,
    reads: 40,
    likes: 39,
    year: 2020,
    status: "available",
  },
  {
    recent: true,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTM22Y46u2x5QffHzE1_hihpCU1y5jjRAmdk4rBPtpx-QEK_bB3rq4QMs06LjRl-7Ukk18&usqp=CAU",
    featured: true,
    title: "Harry Potter",
    tags: ["Moivational"],
    authors: ["Diomidis Spinellis"],
    rating: 4,
    reads: 40,
    likes: 39,
    year: 2020,
    status: "available",
  },
];

export default books;
